<template>
  <div class="sale-try-again">
    <div v-if="status === 'initial'">
      <h5 class="mb-6">
        Tem certeza que deseja tentar realizar a cobrança novamente?
      </h5>
      <div class="snow-submit-buttons mt-7">
        <snow-button
          text="Cancelar"
          variant="gray"
          size="lg"
          @click="$emit('close')"
        />
        <snow-button
          text="Salvar"
          type="submit"
          :loading="loading"
          size="lg"
          @click="retry"
        />
      </div>
    </div>

    <div v-else-if="status === 'change-card'">
      <h5 class="mb-4">
        Não foi possível processar o pagamento.
      </h5>
      <h5 class="mb-4">
        Para nova tentativa, solicite que o cliente recadastre e autorize
      </h5>
      <div class="snow-submit-buttons mt-7">
        <snow-button
          text="Cancelar"
          variant="gray"
          size="lg"
          @click="$emit('close')"
        />
        <snow-button
          text="Salvar"
          type="submit"
          :loading="loading"
          size="lg"
          @click="changeCard"
        />
      </div>
    </div>

    <div v-else-if="status === 'change-card-success'">
      <h5 class="mb-4">
        Foi enviado um e-mail para {{ item.shopper_email }} avisando o cliente
        para recadastrar os dados de pagamento.
      </h5>
      <h5 class="mb-4">
        Caso queria encaminhar por outro canal este é o link 🔗 específico do
        cliente:
      </h5>

      <div class="d-flex gap-2 mb-7">
        <snow-input
          type="text"
          class="w-100"
          readonly
          :value="changeCardLink"
        />
        <snow-button
          @click="copyLink"
          size="lg"
          variant="gray"
          icon="ph ph-copy"
          type="button"
        />
      </div>

      <snow-button
        class="w-100"
        variant="gray"
        size="lg"
        @click="$emit('close')"
      >
        Fechar
      </snow-button>
    </div>
  </div>
</template>

<script>
import get from "lodash/get";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      status: "initial",
      loading: false,
      changeCardLink: ""
    };
  },
  methods: {
    retry() {
      this.loading = true;
      window.axios
        .get(`/subscriptions/reprocess-order/${this.item.id}`)
        .then(response => {
          const msg = get(
            response,
            "data.message",
            "Cobrança realizada com sucesso"
          );
          this.$message.success(msg);
          this.$emit("close");
          this.$emit("refresh");
        })
        .catch(error => {
          const msg = get(
            error,
            "response.data.message",
            "Erro ao realizar cobrança"
          );
          this.$message.error(msg);
          if (get(error, "response.data.change_card")) {
            this.status = "change-card";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeCard() {
      this.loading = true;
      this.$store
        .dispatch("subscriptions/requestChangeCard", this.item.id)
        .then(response => {
          this.$message.success(
            "Um e-mail foi enviado ao cliente com um link para alterar os dados do cartão"
          );
          this.status = "change-card-success";
          this.changeCardLink = response.data.link;
        })
        .catch(() => {
          this.$message.error("Erro");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyLink() {
      let link = this.changeCardLink;
      if (link) {
        navigator.clipboard.writeText(link);
        this.$message.success("Link copiado");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sale-try-again {
  position: relative;

  .btn-close {
    font-size: 20px;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
    background: transparent;
    border: none;
  }

  .btn-copy {
    border: none;
    background: transparent;
    padding: 0;
    font-weight: bold;
  }
}
</style>
